import { navbar } from "../elements";

export function getNavbarHeight(asPixels = true) {
  if (!navbar) return "0px";
  if (asPixels) {
    return `${navbar.offsetHeight}px`;
  }
  return navbar.offsetHeight;
}
